<template>
  <div class="home">
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <el-main>
        <div class="main-view">

          <el-carousel height="30vw">
            <el-carousel-item v-for="item in 4" :key="'carousel-' + item">
              <img src="./imgs/banner.png" alt="" class="banner-img">
            </el-carousel-item>
          </el-carousel>
          <div class="tab-view">
            <div class="contents">
              <a class="label" @click="$router.push('/')">首页</a>
              <div class="line"></div>
              <div class="label" @click="gotoDigitalTextbook">数字教材</div>
              <div class="line"></div>
              <a class="label" @click="gotoDigitalClassroom">数字课堂</a>
              <div class="line"></div>
              <a class="label" @click="gotoDigitalResources">数字资源</a>
              <div class="line"></div>
              <a class="label" @click="gotoKnowledgeService">知识服务</a>
              <div class="line"></div>
              <a class="label" @click="gotoBookList">电子书</a>
              <div class="line"></div>
              <div class="label" @click="gotoNewsList">资讯专栏</div>
              <div class="line"></div>
              <a class="label" @click="gotoContact">联系我们</a>
            </div>
          </div>
        </div>

        <!-- 资讯信息模块 -->
        <div class="news-section">
          <div class="news-container">
            <div class="title-view">
              <div class="l1-title">资讯信息</div>
              <div class="more-link" @click="gotoNewsList">查看更多 ></div>
            </div>

            <div class="news-tabs">
              <div v-for="(tab, index) in newsTabs" :key="'tab-' + index"
                :class="['news-tab', currentNewsTab === tab.value ? 'active' : '']" @click="changeNewsTab(tab.value)">
                {{ tab.label }}
              </div>
            </div>

            <div class="news-list">
              <div v-for="(news, index) in filteredNewsList" :key="'news-' + index" class="news-item"
                @click="gotoNewsDetail(news.id)">
                <img :src="news.coverUrl" alt="" class="news-cover">
                <div class="news-info">
                  <div class="news-title">{{ news.title }}</div>
                  <div class="news-summary">{{ news.summary }}</div>
                  <div class="news-meta">
                    <span
                      :class="['news-category-tag', categoryTagClass(news.categoryId)]"
                    >{{ categoryLabel(news.categoryId) }}</span>
                    <span class="news-time">{{ formatTime(news.publishTime) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main-content">
          <div class="title-view">
            <div class="l1-title">电子科技大学出版社</div>
            <div class="l2-title">关于我们</div>
          </div>
          <div class="text-content">
            电子科技大学出版社（成都电子科大出版社有限责任公司）成立于1985年，由教育部主管、电子科技大学主办，是国家首批“985工程”、“211工程”重点建设高校所属出版社，在原国家新闻出版总署首次出版社评级中被评为国家二级出版社，是四川省人民政府授予的首批重点文化企业，出版骨干企业，入选2014年四川省数字出版转型示范企业。
            <br />
            <br />
            出版社业务范围：出版高等学校及大中专院校教材、教师学术著作；出版科技、经济、文化、少儿、语言、社会科学、生活等类型大众图书；出版电子出版物；出版网络出版物（包括数字教材出版、网络游戏出版）。
          </div>
          <div class="sub-text-content">
            <div class="sub-text-content-left">
              <div class="l2-title">出版特色</div>
              <div class="text-content">
                出版社依托被誉为“中国民族电子工业摇篮”的电子科技大学相关学科优势，坚持走突出“电子信息科学技术”特色的出版之路。经过40余年的发展，树立了以电子信息领域学科为核心的理工类图书出版品牌，赢得社会的普遍赞誉和良好的经济效益，积极谋划出版一大批具有重要影响力的系列教材和高水平学术专著。
              </div>
              <div class="l2-title">数字出版</div>
              <div class="text-content">
                出版社长期致力于探索数字出版的新渠道、新方法，积极实践基于移动互联网的数字出版新模式、新理念，已获知识产权308项，正在申报780多项。
              </div>
              <div class="text-content">
                出版社当前已出版数字教材XX种，出版国产网络游戏76款。
              </div>
              <div class="l2-title">发展愿景</div>
              <div class="text-content">
                电子科技大学出版社将坚持服务党和国家的出版工作方针，弘扬主旋律，为教学科研服务，为人才培养服务的宗旨，坚持以读者为中心，市场为导向，大力实施“人才强社、特色立社、创新兴社”三大发展战略，着力提升经营管理能力和服务社会能力。坚持秉承“求实求真、大气大为”的校训，“拒绝平庸，追求卓越”的成电精神，开拓进取，锐意创新，艰苦奋斗，努力建设成为电子信息学科领域出版高地。
              </div>
            </div>
            <div class="sub-text-content-right">
              <div class="l2-title">重点图书</div>
              <div class="text-content">
                《人文雅鲁藏布大峡谷》（三卷）、《天线工程手册》、《珞渝文化丛书》和《集成电路系统科技创新技术》《鲁班绳墨：中国乡土建筑测绘图集（1～8卷）》《毕摩原生文化系列研究（3卷）》《红色动漫系列丛书》入选国家出版基金项目；
                <br />
                <br />
                《鲁班绳墨：中国乡土建筑测绘图集（1～8卷）》获得第七届中华优秀出版物奖、第五届中国出版政府奖图书奖提名奖、“四川好书”奖；
                <br />
                <br />
                “德耀中华——七彩启德教育”、“《社会主义新农村形象建设：以灾区重建为例》丛书”等2个项目入选新闻出版改革发展项目库；
                <br />
                <br />
                《人文雅鲁藏布大峡谷》（三卷）入选“第二届向全国推荐百种优秀民族图书”；
                <br />
                <br />
                “珞渝文化丛书”、“集成电路系统科技创新技术”、“毒理学安全性评价体系”、《鲁班绳墨：中国乡土建筑测绘图集》等入选国家重点出版物出版规划项目；
                <br />
                <br />
                《高校马克思主义大众化网络宣传平台研究》（2014年）、《强国战略研究》（2016年）入选全国高校出版社主题出版项目；
                <br />
                <br />
                《鲁班绳墨：中国乡土建筑测绘图集》（I、II），《国家战略 区块链应用研究与实战》和《我们的扶贫答卷——教育部脱贫攻坚工作典型案例集》等40余项项目入选四川省重点图书出版规划项目；
              </div>
            </div>
          </div>
          <div class="l2-title" style="text-align: left; margin-top: 28px; margin-left: 0px;">2025成果展示</div>
          <div class="text-content">
            2025年《裴德乐的中国故事》入选国家出版基金2025年主题出版项目；<br />
            <br />
            2025年3月，四川省出版者工作协会发布2024年“四川好书”，我社《噪声与振动测量技术手册》入选。<br />
            <br />
            2025年7月27日，《智能康复学》新书发布会暨“智能康复系列丛书”启动仪式在第四届中国智能康复学术与产业大会上隆重举行。为推动医工交叉融合发展、培育医疗健康新质生产力注入新动力。<br />
            <br />
            2025年10月，中华人民共和国科学技术部公布2024 年度国家科学技术学术著作出版基金资助项目。由我社策划出版的专著《空时调制理论及其阵列天线工程应用》入选。<br />
            <br />
            2025年10月18日，“人工智能+康复学进展与趋势报告暨‘科技创造美好生活’体验分享会”亮相天府书展主会场。第12届世运会火炬手林寒分享了“科技创造美好生活”的亲身经历，现场演绎了科技如何助力康复，让人们不被现状定义未来。<br />
            <br />
            2025年我社精品游戏《都广丹青录》亮相第十五届中国国际数博会，获新华社报道。<br />
            <br />
            2025年11月3日，教育部发布第二批“十四五”职业教育国家规划教材遴选结果，我社出版的《C语言程序设计教程（第2版）》等8种教材入选。<br />
            <br />
            2025年12月10日，由中国大学出版社协会、四川省出版工作者协会联合指导，电子科技大学出版社主办的“智绘十五五&nbsp;&nbsp;出版向未来——出版高质量发展论坛”在电子科大沙河校区圆满举行。<br />
            <br />
            2025年12月13日，中国大学出版社协会2025年年会正式发布了“大学出版好书”公益推荐活动——2025年度百种“大学出版好书”入选书目，电子科技大学刘盛纲院士牵头撰写的学术著作《太赫兹电子学》入选。
          </div>
          <div class="title-view" style="margin-top:90px">
            <div class="l1-title">共建单位</div>
            <div class="l2-title">泛美教育集团</div>
          </div>
          <div class="text-content" style="text-align: justify;">
            四川泛美教育投资集团有限责任公司（以下简称“泛美教育集团”）以“公益教育、精品教育”为宗旨，秉承“纵向贯通、横向融通”的集团化办学思路，在四川成都、四川绵阳、安徽宿州、安徽天长、山东青岛创办了四川西南航空职业学院、绵阳飞行职业学院、宿州航空职业学院、青岛航空科技职业学院、天长泛美航空中等职业技术学校、成都泛美航空旅游中等职业技术学校、宿州中原航空中等专业学校、青岛北方航空职业学校、绵阳泛美飞行职业技术学校、四川西南航空专修学院在内的10所航空院校，教育资产超过百亿元，在校生超过6万人，毕业生就业于国际国内航空公司和民航机场各类岗位。
          </div>
          <div class="text-content" style="text-align: justify;">
            泛美教育集团结合经济高质量发展新时代对人才的需求，实施产教融合发展战略，实施“校中有企、企中有校、校企同质、融合发展”的深度产教融合模式，用专业引领产业、产业促进专业，办一个专业兴一个产业。2023年，联合中国商飞四川公司、中国民航大学共同组建了四川首个商用飞机产教融合共同体。联合中国商飞、中国移动等企业建立了商用飞机产业学院、泛美星程产业学院、5G网联无人机产业学院。牵头成立了包含全国200余家民航企业、通航企业、行业协会以及近100所职业院校的泛美航空职教集团，入选全国第二批示范性职业教育集团（联盟）培育单位，打造了国家级高质量现代职业教育实体化运作平台。
          </div>
          <div class="text-content" style="text-align: justify;">
            未来5年，泛美教育集团将在建设本科专业、建设应用本科院校方面重点发力，打造“中高本一体化、航空产业全覆盖”的全国航空职业教育特色品牌集群，引领中国职业教育新发展。
          </div>
          <div class="text-content" style="text-align: justify;">
            全链条航空教育体系 全覆盖航空专业体系
          </div>
          <div style="margin-top: 20px;text-align: left;"> 
            <img src="./imgs/school_logo.png" alt="泛美教育集团院校" style="width: 45%; margin: 0 auto;" />
          </div>
        </div>
      </el-main>
      <Footer></Footer>
    </el-container>
  </div>
</template>

<script>
import Header from "@/views/components/header/PCHeader.vue";
import Footer from "@/components/Footer.vue";
import NewsApi from "@/api/src/news/api/NewsApi.js";
const newsApi = new NewsApi()

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      currentNewsTab: 0, // 0-全部，1-通知，2-动态，3-政策
      newsTabs: [
        { label: '全部', value: 0 },
        { label: '通知', value: 1 },
        { label: '动态', value: 2 },
        { label: '政策', value: 3 }
      ],
      newsList: []
    }
  },
  computed: {
    filteredNewsList() {
      return this.newsList
    }
  },
  mounted() {
    this.loadNewsList()
  },
  methods: {
    async loadNewsList() {
      try {
        const opts = {
          page: 1,
          pageSize: 6 // 首页只显示6条
        }
        // 如果选择了具体分类（非"全部"），则传递 categoryId 参数
        if (this.currentNewsTab !== 0) {
          opts.categoryId = this.currentNewsTab
        }

        const response = await newsApi.listNews(opts)
        this.newsList = response.list || []
      } catch (error) {
        console.error('加载资讯列表失败:', error)
        this.newsList = []
      }
    },
    gotoBookList() {
      this.$router.push({ name: 'booklist' })
    },
    gotoDigitalTextbook() {
      this.$router.push({ name: 'digitalTextbook' })
    },
    gotoDigitalClassroom() {
      this.$router.push({ name: 'digitalClassroom' })
    },
    gotoDigitalResources() {
      this.$router.push({ name: 'digitalResources' })
    },
    gotoKnowledgeService() {
      this.$router.push({ name: 'knowledgeService' })
    },
    gotoUserspace() {
      this.$router.push({ name: 'userspace' })
    },
    changeNewsTab(value) {
      this.currentNewsTab = value
      this.loadNewsList()
    },
    formatTime(time) {
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    /** 资讯分类：1-通知，2-动态，3-政策（与接口 NewsSummaryVo.categoryId 一致） */
    categoryLabel(categoryId) {
      const tab = this.newsTabs.find(t => t.value === categoryId)
      return tab ? tab.label : '资讯'
    },
    categoryTagClass(categoryId) {
      if (categoryId === 1) return 'news-category-tag--notice'
      if (categoryId === 2) return 'news-category-tag--dynamic'
      if (categoryId === 3) return 'news-category-tag--policy'
      return 'news-category-tag--default'
    },
    gotoNewsList() {
      this.$router.push({ name: 'news' })
    },
    gotoNewsDetail(id) {
      this.$router.push({ name: 'newsDetail', params: { id } })
    },
    gotoContact() {
      this.$router.push({ name: 'contact' })
    }
  },
}
</script>

<style lang="less" scoped>
@import '@/styles/layout.less';

.el-header {
  background-color: #FFFFFF;
  color: #333;
  text-align: center;
  line-height: 60px;
}


.el-main {
  background-color: #ffffff;
  color: #333;
  text-align: center;
}

.el-footer {
  background-color: #F6F6F6;
  color: #333;
  text-align: center;
  height: 306px;
}


/deep/ .el-main {
  background-color: #FFFFFF;
  color: #333;
  text-align: center;
  padding: 0px;
}

.main-view {
  display: flex;
  flex-direction: column;

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .tab-view {
    height: 60px;
    background: #0F5EBF;

    .contents {
      display: flex;
      flex-direction: row;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
      padding: 0 24px;
      box-sizing: border-box;
      align-items: center;

      .label {
        cursor: pointer;
        flex: 1;
        line-height: 60px;
        color: white;
      }

      .line {
        height: 20px;
        width: 1px;
        background: white;
      }
    }
  }
}

.main-content {
  display: flex;
  flex-direction: column;
  .page-container();
  margin-top: 80px;
  margin-bottom: 80px;

  .tablet-down({
    margin-top: 48px;
    margin-bottom: 48px;

    .sub-text-content {
      flex-direction: column;

      .sub-text-content-left {
        margin-right: 0;
      }

      .sub-text-content-right {
        margin-left: 0;

        .l2-title {
          margin-top: 24px;
        }
      }
    }
  });

  .l1-title {
    color: #0F5EBF;
    font-size: 30px;
    font-weight: bold;
  }

  .l2-title {
    color: #666666;
    font-size: 20px;
    margin-left: 30px;
    font-weight: bold;
  }

  .title-view {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .text-content {
    font-weight: 400;
    font-size: 15px;
    color: #333333;
    text-align: left;
    line-height: 28px;
    margin-top: 20px;
    text-align: justify;
  }

  .sub-text-content {
    display: flex;
    flex-direction: row;

    .l2-title {
      margin-left: 0px;
      margin-top: 30px;
    }

    .sub-text-content-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-right: 60px;
    }

    .sub-text-content-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 60px;

      .text-content {
        line-height: 29px;
      }
    }
  }
}

// 资讯信息模块样式
.news-section {
  background-color: #F6F6F6;
  padding: 60px 0;

  .tablet-down({
    padding: 40px 0;

    .news-container .news-tabs .news-tab {
      padding: 12px 16px;
      font-size: 15px;
    }

    .news-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 18px;

      .news-item .news-info {
        padding: 16px;
      }
    }
  });

  .news-container {
    margin: 0 auto;
    .page-container();

    .title-view {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .l1-title {
        color: #0F5EBF;
        font-size: 30px;
        font-weight: bold;
      }

      .more-link {
        color: #0F5EBF;
        font-size: 14px;
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .news-tabs {
      display: flex;
      flex-direction: row;
      margin-bottom: 30px;
      border-bottom: 2px solid #E5E5E5;

      .news-tab {
        padding: 12px 30px;
        font-size: 16px;
        color: #666666;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        &:hover {
          color: #0F5EBF;
        }

        &.active {
          color: #0F5EBF;
          font-weight: bold;

          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: #0F5EBF;
          }
        }
      }
    }

    .news-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;

      .news-item {
        background: #FFFFFF;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.12);
        }

        .news-cover {
          width: 100%;
          height: 180px;
          object-fit: cover;
        }

        .news-info {
          padding: 20px;

          .news-title {
            font-size: 16px;
            font-weight: bold;
            color: #191919;
            line-height: 24px;
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }

          .news-summary {
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            margin-bottom: 15px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }

          .news-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            font-size: 12px;
            color: #999999;

            .news-category-tag {
              flex-shrink: 0;
              padding: 2px 10px;
              border-radius: 4px;
              font-size: 12px;
              line-height: 18px;
            }

            .news-category-tag--notice {
              background: #e9f2f8;
              color: #0f5ebf;
            }

            .news-category-tag--dynamic {
              background: #fef5e6;
              color: #ed6b00;
            }

            .news-category-tag--policy {
              background: #dcfce7;
              color: #15803d;
            }

            .news-category-tag--default {
              background: #f0f0f0;
              color: #666666;
            }

            .news-time {
              flex-shrink: 0;
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
